var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentMovementsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4634_260",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.126953,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4634_260)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.30775 20.4348L3 16.1271L7.30775 11.8193L8.02125 12.5271L4.92125 15.6271H20V16.6271H4.92125L8.02125 19.7271L7.30775 20.4348ZM16.6923 12.4348L15.9788 11.7271L19.0788 8.62709H4V7.62709H19.0788L15.9788 4.52709L16.6923 3.81934L21 8.12709L16.6923 12.4348Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentMovementsIcon);
export default __webpack_public_path__ + "static/media/payment-movements-icon.e849411d48c424d07c459bc3d721b3f1.svg";
export { ForwardRef as ReactComponent };